// extracted by mini-css-extract-plugin
module.exports = {"container":"_1WC5QkmghObQYjoaL7XaNd"};